export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 9_10.4ff433fa.jpg";